module.exports = __webpack_public_path__ + "static/img/アセット 56@3x.18b9efe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/アセット 56@3x.png
// module id = 3NyW
// module chunks = 1